<template>
  <div>
    <b-form>
      <b-row class="mb-3">
        <b-col :sm="isCompactView ? 12 : 6">
          <csr-initiative
            :csrInitiative="form"
            :isPreview="true"
            :isCampaign="true"
            class="mb-3"
          />
        </b-col>
        <b-col :sm="isCompactView ? 12 : 6">
          <!-- Headline Field -->
          <b-row class="my-3">
            <b-col sm="3" class="text-left align-items-center">
              <label for="collective-goal-headline" class="form-label">Headline</label>
            </b-col>
            <b-col sm="9">
              <b-form-input
                id="collective-goal-headline"
                v-model="form.headline"
                size="sm"
                type="text"
                placeholder="(e.g.) Every action makes our planet greener!"
                required
              />
            </b-col>
          </b-row>
          <!-- Emoji Field -->
          <b-row class="my-3">
            <b-col sm="3" class="text-left align-items-center">
              <label for="collective-goal-icon" class="form-label">Emoji</label>
            </b-col>
            <b-col sm="9">
              <b-form-input
                id="collective-goal-icon"
                v-model="form.icon"
                size="sm"
                type="text"
                placeholder="Pick an Emoji for your Goal (e.g. 🍃)"
                required
              />
              <span class="text-muted help-text">To show Emojis, hold ⌃⌘Space on Mac, and Windows Logo + . (period) on Windows</span>
            </b-col>
          </b-row>
          <!-- Description Field -->
          <b-row class="mt-3 mb-1">
            <b-col sm="3" class="text-left align-items-center">
              <label for="collective-goal-description" class="form-label">Description</label>
            </b-col>
            <b-col sm="9">
              <b-form-textarea
                id="collective-goal-description"
                v-model="form.description"
                placeholder="Describe your Goal..."
                size="sm"
                rows="3"
                max-rows="6"
                required
              />
              <span class="text-muted help-text">Describe your collective goal in a few words.</span>
            </b-col>
          </b-row>
          <!-- Status Field -->
          <b-row class="mt-3 mb-1">
            <b-col sm="3" class="text-left align-items-center">
              <label for="collective-goal-description" class="form-label">Status</label>
            </b-col>
            <b-col sm="9">
              <b-form-select
                id="collective-goal-status"
                v-model="form.status"
                size="sm"
                :options="statusOptions"
                required
              >
              </b-form-select>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <!-- Unit Title -->
      <div class="d-flex justify-content-start">
          <h3 class="pl-2 ml-1 mt-3"><b>Unit</b></h3>
        </div>
        <!-- Unit Card -->
        <b-card v-for="(unit, index) in form.units" :key="index" no-body class="rounded mb-2 p-3">
          <!-- Unit Name Field -->
          <b-row class="p-2">
            <b-col sm="3" class="text-left align-items-center">
              <label for="unit-name" class="unit-label">Name</label>
            </b-col>
            <b-col sm="9">
              <b-form-input
                :id="`unit-name-${index}`"
                v-model="unit.name"
                size="sm"
                type="text"
                required
              />
              <span class="text-muted help-text">Add the name of the desired unit to track goal progress.</span>
            </b-col>
          </b-row>
          <!-- Unit Goal Value Field -->
          <b-row class="p-2">
            <b-col sm="3" class="text-left align-items-center">
              <label for="unit-goal-value" class="unit-label">Goal Value</label>
            </b-col>
            <b-col sm="9">
              <b-form-input
                :id="`unit-goal-value-${index}`"
                v-model="unit.monthlyGoal.totalSum"
                size="sm"
                type="number"
                required
              />
              <span class="text-muted help-text">Choose a target value for your goal (e.g. 126)</span>
            </b-col>
          </b-row>
          <!-- Unit Goal Text Field -->
          <b-row class="p-2">
            <b-col sm="3" class="text-left align-items-center">
              <label for="unit-goal-text" class="unit-label">Goal Text</label>
            </b-col>
            <b-col sm="9">
              <b-form-input
                :id="`unit-goal-text-${index}`"
                v-model="unit.monthlyGoal.text"
                size="sm"
                type="text"
                required
              />
              <span class="text-muted help-text">Add a few words to encourage everyone to participate.</span>
            </b-col>
          </b-row>
          <!-- Unit Value Conversion Field -->
          <b-row class="p-2">
            <b-col sm="3" class="text-left align-items-center">
              <label for="unit-goal-value-conversion" class="unit-label">Value Conversion</label>
            </b-col>
            <b-col sm="9">
              <b-form-input
                :id="`unit-goal-value-conversion-${index}`"
                v-model="unit.conversion"
                size="sm"
                type="number"
                required
              />
              <span class="text-muted help-text">Choose a unit convertion ratio for your goal (e.g. 0.037)</span>
            </b-col>
          </b-row>
          <!-- Unit Display First Line Field -->
          <b-row class="p-2">
            <b-col sm="3" class="text-left align-items-center">
              <label for="unit-display-first-line" class="unit-label">Display First Line</label>
            </b-col>
            <b-col sm="9">
              <b-form-input
                :id="`unit-display-first-line-${index}`"
                v-model="unit.display.firstLine"
                size="sm"
                type="text"
                required
              />
              <span class="text-muted help-text">Type the first line of your unit field</span>
            </b-col>
          </b-row>
          <!-- Unit Display Second Line Field -->
          <b-row class="p-2">
            <b-col sm="3" class="text-left align-items-center">
              <label for="unit-display-second-line" class="unit-label">Display Second Line</label>
            </b-col>
            <b-col sm="9">
              <b-form-input
                :id="`unit-display-second-line-${index}`"
                v-model="unit.display.secondLine"
                size="sm"
                type="text"
                required
              />
              <span class="text-muted help-text">Type the second line of your unit field</span>
            </b-col>
          </b-row>
        </b-card>
    </b-form>
    <b-row>
      <b-col>
        <b-link v-b-modal.scores-modal>Update Score System</b-link>
      </b-col>
    </b-row>
    <!-- Bottom Buttons & Actions -->
    <div class="d-flex justify-content-between align-items-center">
      <div class="flex-fill"/>
      <div class="d-flex justify-content-end align-items-center">
        <div class="flex-fill"></div>
        <b-btn @click="input()" variant="primary" class="m-2">Save</b-btn>
      </div>
    </div>

    <b-modal id="scores-modal" title="Update Score System" size="xl" hide-footer>
      <update-score-system :value="form.scores" @input="updateScores"/>
    </b-modal>
  </div>
</template>

<script>
import CsrInitiative from '@/components/dashboard/CsrInitiative';
import UpdateScoreSystem from '@/components/campaign-admin/update-score-system';

const defaultScores = [
  {
    id: 'shares',
    icon: 'link',
    label: 'Shares',
    value: 1,
    eventNames: [ 'JOB_SHARED', 'CONTENT_SHARED', 'JOB_BROWSE_LINKEDIN', 'JOB_SCHEDULE_SHARE_FIRST', 'CONTENT_SCHEDULE_SHARE_FIRST', 'EVENT_REFERRAL_CREATED', 'REFERRAL_SUGGESTED' ],
    maximum: 5,
  },
];

const defaultUnit = {
  conversion: null,
  name: '',
  monthlyGoal: {
    totalSum: null,
    text: '',
  },
  display: {
    firstLine: '',
    secondLine: '',
  },
  showWholeYearTotal: false
};

export default {
  components: {
    CsrInitiative,
    UpdateScoreSystem
  },
  props: {
    value: {
      type: Object,
    },
    isCompactView: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    const { collectiveGoal } = this.value || {};
    const form = collectiveGoal ? JSON.parse(JSON.stringify(collectiveGoal)) : {};
    if (form.__typename) delete form.__typename;
    if (!Array.isArray(form.units) || form.units.length === 0) {
      form.units = [ { ...defaultUnit } ];
    };
    form.units = form.units.map(el => {
      if (el && el.__typename) delete el.__typename;
      if (el && el.monthlyGoal && el.monthlyGoal.__typename) delete el.monthlyGoal.__typename;
      if (el && el.display && el.display.__typename) delete el.display.__typename;
      return el;
    });
    console.log('FORM IS: ', form);
    return {
      showPreview: false,
      form: {
        headline: '',
        icon: '',
        description: '',
        status: 'DRAFT',
        scores: defaultScores,
        ...form,
      },
    };
  },
  methods: {
    input() {
      const collectiveGoal = this.form;
      collectiveGoal.units = (collectiveGoal.units || []).map(el => {
        el.conversion = typeof el.conversion === 'string' ? parseFloat(el.conversion) : el.conversion;
        if (el.monthlyGoal) {
          el.monthlyGoal.totalSum = typeof el.monthlyGoal.totalSum === 'string' ? parseFloat(el.monthlyGoal.totalSum) : el.monthlyGoal.totalSum;
        };
        return el;
      });
      const component = { collectiveGoal: this.form };
      this.$emit('input', component);
    },
    togglePreview() {
      this.showPreview = !this.showPreview;
    },
    updateScores(scores) {
      this.form.scores = scores;
      console.log('Scores: ', this.form.scores);
      this.$bvModal.hide('scores-modal');
    }
  },
  computed: {
    statusOptions: () => ([
      { value: 'DRAFT', text: 'Draft' },
      { value: 'ACTIVE', text: 'Active' },
      { value: 'INACTIVE', text: 'Inactive' },
    ])
  }
};
</script>

<style lang="scss">
.referral-jam-event-settings {
  .event-logo {
    max-height: 30px;
    max-width: 200px;
  }
}
.form-label {
  font-size: 1rem;
}
.unit-label {
  font-size: 0.9rem;
}
.help-text {
  font-size: 0.75rem;
}
.hidden {
  visibility: hidden;
}
.delete-styling:hover {
  font-weight: bold;
  color: red;
}
.add-styling:hover {
  font-weight: bold;
  color: green;
}
</style>


// WEBPACK FOOTER //
// src/components/campaign-admin/update-collective-goal.vue